"use strict";
// @TODO each enum should have additional details
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthFeature = exports.LifeStage = exports.FoodForm = void 0;
var FoodForm;
(function (FoodForm) {
    FoodForm["DRY"] = "DRY";
    FoodForm["WET"] = "WET";
    FoodForm["PRESCRIPTION"] = "PRESCRIPTION";
    FoodForm["FREEZE_DRIED"] = "FREEZE_DRIED";
    FoodForm["HUMAN_GRADE"] = "HUMAN_GRADE";
    FoodForm["DEHYDRATED"] = "DEHYDRATED";
    FoodForm["FROZEN"] = "FROZEN";
    FoodForm["TOPPINGS"] = "TOPPINGS";
    FoodForm["TREATS"] = "TREATS";
})(FoodForm = exports.FoodForm || (exports.FoodForm = {}));
var LifeStage;
(function (LifeStage) {
    LifeStage["NEW_BORN"] = "NEW_BORN";
    LifeStage["PUPPY"] = "PUPPY";
    LifeStage["ADOLESCENCE"] = "ADOLESCENCE";
    LifeStage["ADULT"] = "ADULT";
    LifeStage["SENIOR"] = "SENIOR";
    LifeStage["ALL_STAGES"] = "ALL_STAGES";
})(LifeStage = exports.LifeStage || (exports.LifeStage = {}));
var HealthFeature;
(function (HealthFeature) {
    HealthFeature["DIGESTIVE_HEALTH"] = "DIGESTIVE_HEALTH";
    HealthFeature["SKIN_COAT_HEALTH"] = "SKIN_COAT_HEALTH";
    HealthFeature["HIP_JOINT_SUPPORT"] = "HIP_JOINT_SUPPORT";
    HealthFeature["HIGH_ENERGY"] = "HIGH_ENERGY";
    HealthFeature["BRAIN_HEALTH"] = "BRAIN_HEALTH";
    HealthFeature["KIDNEY_CARE"] = "KIDNEY_CARE";
    HealthFeature["URINARY_TRACT_HEALTH"] = "URINARY_TRACT_HEALTH";
    HealthFeature["DENTAL_BREATH_CARE"] = "DENTAL_BREATH_CARE";
    HealthFeature["IMMUNE_SUPPORT"] = "IMMUNE_SUPPORT";
    HealthFeature["HEALTH_CARE"] = "HEALTH_CARE";
    HealthFeature["SENSITIVE_SKIN"] = "SENSITIVE_SKIN";
    HealthFeature["CALMING"] = "CALMING";
    HealthFeature["DIABETIC_SUPPORT"] = "DIABETIC_SUPPORT";
    HealthFeature["LIVER_CARE"] = "LIVER_CARE";
    HealthFeature["EAR_CARE"] = "EAR_CARE";
    HealthFeature["EYE_CARE"] = "EYE_CARE";
    HealthFeature["TEAR_STAIN_REMOVAL"] = "TEAR_STAIN_REMOVAL";
    HealthFeature["VITAMINS_MINERALS"] = "VITAMINS_MINERALS";
})(HealthFeature = exports.HealthFeature || (exports.HealthFeature = {}));
